module.exports = __webpack_public_path__ + "static/media/megaphone-icon.99a2675d.svg";